import { sbsCompanyAPI } from "./api";

export const getSbsCompanyList = async (params) => {
  try {
    const res = await sbsCompanyAPI.getSbsCompanyList(params);
    const data = res?.data;
    const total = res?.total_count;
    return { data, total };
  } catch (e) {}
};

export const sbsCompanyTableColumns = [
  {
    name: "sbs_company_id",
    required: true,
    label: "ID проекта",
    align: "center",
    field: "sbs_company_id",
    sortable: true,
  },
  {
    name: "naimenovanie",
    required: true,
    label: "Наименование",
    align: "left",
    field: "naimenovanie",
    sortable: true,
  },
  {
    name: "key__ssylka",
    required: true,
    label: "key__ssylka",
    align: "left",
    field: "key__ssylka",
    sortable: true,
  },
  {
    name: "ssylka__id",
    required: true,
    label: "ssylka__id",
    align: "left",
    field: "ssylka__id",
    sortable: true,
  },
  {
    name: "osnovnoy_vid_deyatelnosti__view",
    required: true,
    label: "Вид деятельности",
    align: "left",
    field: "osnovnoy_vid_deyatelnosti__view",
    sortable: true,
  },
  {
    name: "identifikatsionnyy_nomer",
    required: true,
    label: "Идентификационный номер",
    align: "center",
    field: "identifikatsionnyy_nomer",
    sortable: true,
  },
  {
    name: "data_svidetelstva_po_nds",
    required: true,
    label: "Дата свидетельства по НДС",
    align: "center",
    field: "data_svidetelstva_po_nds",
    sortable: true,
  },
  {
    name: "date_modified",
    required: true,
    label: "Дата модификации",
    align: "center",
    field: "date_modified",
    sortable: true,
  },
  {
    name: "updated_at",
    required: true,
    label: "Дата обновления",
    align: "center",
    field: "updated_at",
    sortable: true,
  },
];
